import * as React from 'react';
import Box from '@mui/material/Box';
import TablePagination from '@mui/material/TablePagination';
import Paper from '@mui/material/Paper';
import { useTranslation } from 'react-i18next';

export const TableWrapper: React.FC<TableProps> = (props) => {
    const [page, setPage] = React.useState(0);
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const { t } = useTranslation();
    const rows = props.rows;

    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage);
        props.paginationHandle(event, newPage);
    };

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement>
    ) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
        props.handleChangeRowsPerPage(event);
    };

    return (
        <Box sx={{ width: '100%' }}>
            <Paper sx={{ width: '100%', mb: 2 }}>
                {props.children}
                <TablePagination
                    rowsPerPageOptions={[2, 5, 10, 25, 50, 100]}
                    component="div"
                    count={rows.length}
                    rowsPerPage={rowsPerPage}
                    page={page}
                    onPageChange={handleChangePage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    labelRowsPerPage={t('TABLE_PAGINATOR.ROWS_PER_PAGE')}
                    labelDisplayedRows={({ from, to, count }) => {
                        return t('TABLE_PAGINATOR.ROWS', {
                            from: from,
                            to: to,
                            count: count,
                        });
                    }}
                    showFirstButton
                    showLastButton
                />
            </Paper>
        </Box>
    );
};

interface TableProps {
    children: React.ReactNode;
    rows: any;
    paginationHandle: (event: unknown, newPage: number) => void;
    handleChangeRowsPerPage: (event: unknown) => void;
}
